export const DarkTheme = {
  colors: {},
}
